import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import Swal from "sweetalert";

import { getCaracteristicasArticulo } from "../repository";

const FUNCION_LABEL = "Función y beneficios del producto";

const ProductSpecifications = (props) => {
  const [caracteristicas, setCaracteristicas] = useState([]);
  const [funcionBeneficios, setFuncionBeneficios] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const codigo = props.codigo;

  useEffect(() => {
    buscaCaracteristicas();
  }, []);

  const buscaCaracteristicas = () => {
    getCaracteristicasArticulo(codigo)
      .then((response) => {
        if (response.status === "success") {
          const all = response.result || [];
          const funcion = all.find(
            (i) =>
              (i.Caracteristica || "").trim().toLowerCase() ===
              FUNCION_LABEL.toLowerCase()
          );
          const specs = all.filter(
            (i) =>
              (i.Caracteristica || "").trim().toLowerCase() !==
              FUNCION_LABEL.toLowerCase()
          );
          setCaracteristicas(specs);
          setFuncionBeneficios(funcion ? funcion.Valor : null);
          setIsLoading(false);
        } else if (
          (response.message || "").toLowerCase().startsWith("no se encontró información")
        ) {
          setCaracteristicas([]);
          setFuncionBeneficios(null);
          setIsLoading(false);
        } else {
          setCaracteristicas([]);
          setFuncionBeneficios(null);
          setIsLoading(false);
          Swal(
            "Error obtener la información [Especificaciones]",
            response.message,
            "error"
          );
        }
      })
      .catch((err) => {
        setIsLoading(false);
        Swal("Error obtener la información [Especificaciones]", err, "error");
      });
  };

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      props.closeModal();
    }
  };

  return ReactDOM.createPortal(
    <div className="image-zoom-overlay" onClick={handleBackdropClick}>
      <div className="image-zoom-modal" style={{ maxWidth: "800px" }}>
        <div className="image-zoom-header">
          <h5 className="image-zoom-title">
            <span className="badge badge-light ml-1 mr-1">
              {caracteristicas.length}
            </span>
            <small>
              {caracteristicas.length === 1 ? "Especificación" : "Especificaciones"}
              &nbsp;de:&nbsp;
            </small>
            <span className="badge badge-dark ml-1 mr-1">{codigo}</span>
          </h5>
          <button
            type="button"
            className="image-zoom-close"
            aria-label="Cerrar"
            onClick={props.closeModal}
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="image-zoom-body product-apps-body">
          <div className="container-fluid w-100">
            <div className="row bg-secondary text-white py-2">
              <div className="col-6">
                <small><strong>Característica</strong></small>
              </div>
              <div className="col-6">
                <small><strong>Valor</strong></small>
              </div>
            </div>
            {isLoading ? (
              <div className="text-center py-3">
                <p>Cargando...</p>
                <div
                  className="spinner-border text-warning"
                  role="status"
                  aria-hidden="true"
                ></div>
              </div>
            ) : caracteristicas.length === 0 && !funcionBeneficios ? (
              <div className="text-center py-5">
                <i
                  className="fas fa-info-circle text-muted mb-3"
                  style={{ fontSize: "2.5rem", display: "block" }}
                ></i>
                <p className="mb-1">
                  <strong>Sin especificaciones técnicas</strong>
                </p>
                <p className="mb-0 text-muted">
                  <small>Este producto aún no tiene una ficha técnica disponible.</small>
                </p>
              </div>
            ) : (
              <>
                {caracteristicas.map((item, index) => (
                  <div
                    className="row bg-light border-bottom"
                    key={index + codigo + item.Caracteristica}
                  >
                    <div className="col-6 border-right">
                      <small>{item.Caracteristica}</small>
                    </div>
                    <div className="col-6">
                      <small>{item.Valor}</small>
                    </div>
                  </div>
                ))}
                {funcionBeneficios && (
                  <div className="mt-3 p-3 bg-light border rounded">
                    <p className="mb-1">
                      <strong>
                        <small>{FUNCION_LABEL}</small>
                      </strong>
                    </p>
                    <p className="mb-0">
                      <small>{funcionBeneficios}</small>
                    </p>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
        <div className="image-zoom-footer">
          <button
            type="button"
            className="btn btn-secondary"
            onClick={props.closeModal}
          >
            Cerrar
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default ProductSpecifications;
